import { domain } from 'modules/data';

export const excludedIntegrationCodes: (domain.IntegrationCode | null)[] = [domain.IntegrationCode.NetSuiteRA];
